module.exports = __webpack_public_path__ + "media/images/check-box-desmarcado-a6f08da26b139dba6d88b53802cfd1f3.svg";